export const hexToRgba = (hexColor: string, alpha: number) => {
  const sanitized = hexColor.replace('#', '');
  const isShort = sanitized.length === 3;
  const hex = isShort
    ? sanitized
        .split('')
        .map((char) => char + char)
        .join('')
    : sanitized;
  const int = Number.parseInt(hex, 16);
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
